export const PowerPage = () => {
    return <>PowerPage</>
}